import { ApiService } from "./api.service";
export default class SettingsService extends ApiService {
  template = "defaultTemplate";
  icon = "Gear";
  DOMAIN = -10;
  favicon = "Gear";
  constructor() {
    super("settings");
  }
}
